import React from 'react';
import { Outlet } from 'react-router-dom';
import MobileNav from './mobile-nav/mobile-nav';
import Footer from './footer/footer';
import DesktopNav from './desktop-nav/desktop-nav';
import { useScreenSizeContext } from '../../util/screensize.context';
import { createPortal } from 'react-dom';
import CookieConsentController from '../cookie-consent/controller/cookie-consent-controller';

const Layout = () => {
  const { isScreenLargeOrMore } = useScreenSizeContext();
  return (
    <>
      {!isScreenLargeOrMore && <MobileNav />}
      <DesktopNav />
      <Outlet />
      <Footer />
      {createPortal(<CookieConsentController />, document.body)}
    </>
  );
};

export default Layout;
